import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {CommonModule} from '@angular/common';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
        <h2>{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="close(false)">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="dialog-content">
        <p class="message-text" [innerHTML]="formatMessage(data.message)"></p>
      </mat-dialog-content>

      <mat-dialog-actions class="dialog-actions">
        <button  class="cancel-button" (click)="close(false)">
          {{ data.cancelText || 'CANCEL' }}
        </button>
        <button class="save-button" (click)="close(true)">
          {{ data.confirmText || 'SAVE' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .dialog-container {
      border: 1px;
      border-radius: 1px;
      padding: 0;
      min-width: 500px;
      max-height: 400px;
      background-color: rgba(255, 255, 255, 1);
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      background-color: #000;
      color: white;
    }

    .dialog-header h2 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .close-button {
      color: white;
    }

    .close-button:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .dialog-content {
      padding: 32px 24px;
      text-align: center;
      font-size: 20px;
      margin: 30px;
      color: #333;
    }

    .dialog-content p {
      margin: 0;
    }

    .message-text {
      white-space: pre-line;
      line-height: 1.5;
    }

    .dialog-actions {
      padding: 0 24px 24px;
      display: flex;
      justify-content: end;
      gap: 16px;
    }

    .cancel-button {
      padding: 10px ;
      border: 1px solid rgba(39, 198, 50, 1);
      color: rgba(39, 198, 50, 1);
      background-color: white;
      font-weight: 500;
      border-radius: 8px;
      min-width: 90px;
      max-height: 45px;
    }

    .cancel-button:hover {
      background-color: #f8f9fa;
    }

    .save-button {
      padding: 10px;
      background-color:rgba(39, 198, 50, 1);
      border: 1px solid rgba(39, 198, 50, 1);
      color: white;
      border-radius: 8px;
      font-weight: 500;
      min-width: 90px;
      max-height: 45px;
    }

    .save-button:hover {
      background-color: #218838;
    }

    ::ng-deep .mat-mdc-dialog-container {
      padding: 0 !important;
      border-radius: 8px;
      overflow: hidden;
    }

    ::ng-deep .mat-mdc-dialog-surface {
      padding: 0 !important;
    }
  `],
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatIcon,
    MatIconButton,
    CommonModule
  ]
})
export class ConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  close(result: boolean) {
    this.dialogRef.close(result);
  }

  formatMessage(message: string): string {
    // Convert newlines to <br> tags for proper HTML rendering
    return message.replace(/\n/g, '<br>');
  }
}
